/*
The idea of this: This action gets dispatched on the client only.
This way, we can do stuff on the client once we are sure that Redux is fully
initialised on the client.

This seems necessary for the login form: If we don't do this, values can be entered
into input fields which are then unknown / ignored by redux-form.
*/

export const CLIENT_INIT = 'CLIENT_INIT'



// WEBPACK FOOTER //
// ./src/app/actions/client-only.js